var render = function render(){var _vm=this,_c=_vm._self._c;return (this.logged_in === true)?_c('div',[_c('v-app',[_c('NavDrawer',{attrs:{"roles":this.roles,"cur_role":this.cur_role}}),_c('v-main',{staticClass:"mx-8"},[_c('router-view')],1)],1)],1):_c('div')
}
var staticRenderFns = []

export { render, staticRenderFns }